import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'dk-jor-angular',
  templateUrl: './jor-angular.component.html',
  styleUrls: ['./jor-angular.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class JorAngularComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
